import React from 'react'
import PropTypes from 'prop-types'
import InputContainer from '../../../../../../../../../../../common/input'

const BookingServicePropertyForm = ({
  property,
  formErrors,
  handleClose,
  availableValues,
  handleSubmit,
  setCurrentValue,
  currentValue,
}) => {
  const getInput = (property) => {
    switch (property.type) {
      case 'INT':
        return (
          <InputContainer
            label="New Value"
            type="number"
            value={currentValue}
            error={formErrors.currentValue}
            className="service-property-form__field"
            onInputChange={setCurrentValue}
          />
        )
      case 'STRING':
        return (
          <InputContainer
            label="New Value"
            type="text"
            value={currentValue}
            error={formErrors.currentValue}
            className="service-property-form__field"
            onInputChange={setCurrentValue}
          />
        )
      case 'JSON':
        return (
          <InputContainer
            label="Service"
            textArea
            value={currentValue}
            error={formErrors.currentValue}
            className="service-property-form__field"
            onInputChange={setCurrentValue}
          />
        )
      case 'SELECT':
        return (
          <wb-select-control>
            <wb-select aria-labelledby="IdOfError">
              <label>New Value</label>
              <select
                value={currentValue}
                onChange={(e) => setCurrentValue(e.target.value)}
              >
                <option>Please choose</option>
                {availableValues &&
                  availableValues.map((val) => (
                    <option key={val} value={val}>
                      {val}
                    </option>
                  ))}
              </select>
            </wb-select>
            <div>
              {formErrors.currentValue && (
                <wb-control-error id="IdOfError">
                  {formErrors.currentValue}
                </wb-control-error>
              )}
            </div>
          </wb-select-control>
        )
    }
  }
  return (
    <div className="service-property-form">
      <h3 className="service-property-form__header wb-type-heading-xs wb-margin-bottom-xs">
        Edit Property
        <span className="wb-margin-start-xs">
          <wb-tooltip-host position="top">
            <button
              className="wb-round-button wb-round-button--solid-level-0 wb-round-button--small"
              type="button"
            >
              <wb-icon name="bds/question-mark/16"></wb-icon>
            </button>
            <wb-tooltip>
              Please enter new value for selected property
            </wb-tooltip>
          </wb-tooltip-host>
        </span>
      </h3>
      <fieldset className="service-property-form__field wb-margin-bottom-xs">
        <InputContainer
          label="Current Value"
          value={property.value}
          onInputChange={console.log}
          isDisabled={true}
        />
      </fieldset>
      <fieldset className="service-property-form__field wb-margin-bottom-xs">
        {getInput(property)}
      </fieldset>
      <div style={{ float: 'right' }}>
        <button
          type="button"
          className="wb-button wb-button--secondary wb-button--small"
          onClick={handleClose}
        >
          Cancel
        </button>
        <button
          type="button"
          onClick={handleSubmit}
          className="wb-button wb-button--primary wb-button--small wb-margin-start-s"
        >
          Submit
        </button>
      </div>
    </div>
  )
}

export default BookingServicePropertyForm
